import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, type AIContentType } from "../api";
import { Button } from "./ui";

interface Props {
  bookId: number;
  size?: "sm" | "md" | "lg";
  variant?: "primary" | "ghost" | "gold";
}

export function GenerateAllButton({ bookId, size = "sm", variant = "ghost" }: Props) {
  const qc = useQueryClient();

  const trigger = useMutation({
    mutationFn: () => api.post<{ started: AIContentType[]; skipped: AIContentType[] }>(`/ai/${bookId}/generate-all`),
    onSuccess: (res) => {
      // Invalidate every AI section so they re-fetch status and start polling.
      const types: AIContentType[] = [
        "chapters", "characters", "themes", "venue", "pairings",
        "questions", "passages", "context", "relationships",
        "merch",
      ];
      for (const t of types) {
        qc.invalidateQueries({ queryKey: ["ai", bookId, t] });
      }
      // Tiny user feedback via the button label
      if (res.started.length === 0) {
        // Nothing to do — silent success
      }
    },
  });

  const label = trigger.isPending
    ? "Sending Claude to work…"
    : trigger.isSuccess
    ? trigger.data.started.length > 0
      ? `Generating ${trigger.data.started.length} sections…`
      : "Everything's already filled in"
    : "✨ Fill in all sections";

  return (
    <Button
      size={size}
      variant={variant}
      onClick={() => trigger.mutate()}
      loading={trigger.isPending}
    >
      {label}
    </Button>
  );
}
